// src/components/Modal.js
import React from "react";

export const Modal = ({ show, onClose, title, children, size = "md", zIndex = "z-50" }) => {
  if (!show) return null;

  const sizeClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    "2xl": "max-w-2xl",
    "3xl": "max-w-3xl",
    "4xl": "max-w-4xl",
    "5xl": "max-w-5xl",
    "6xl": "max-w-6xl", // Novo tamanho largo
    "7xl": "max-w-7xl", // Novo tamanho extra largo (ideal para tabelas)
  };

  return (
    <div className={`fixed inset-0 ${zIndex} flex items-center justify-center bg-black bg-opacity-75 transition-opacity`}>
      <div
        className={`bg-white rounded-lg shadow-xl transform transition-all sm:my-8 w-full ${sizeClasses[size] || sizeClasses.md} mx-4`}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b rounded-t-lg bg-gray-100">
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          <button
            onClick={onClose}
            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
          >
            <svg
              className="w-5 h-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 
                8.586l4.293-4.293a1 1 0 111.414 
                1.414L11.414 10l4.293 4.293a1 1 
                0 01-1.414 1.414L10 11.414l-4.293 
                4.293a1 1 0 01-1.414-1.414L8.586 
                10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              ></path>
            </svg>
          </button>
        </div>
        <div className="p-4 md:p-5 space-y-4 max-h-[85vh] overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
};